"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBorderColor = exports.RadioIcon = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _radioTheme = require("./radioTheme");
const getBorderWidth = props => {
  if (props.isHovered && !props.isDisabled) {
    return _radioTheme.radioIconTheme.borderWidth.hover(props.themeMode);
  }
  if (props.isChecked) {
    if (props.size === "large") {
      return _radioTheme.radioIconTheme.borderWidth.checked.large(props.themeMode);
    } else {
      return _radioTheme.radioIconTheme.borderWidth.checked.medium(props.themeMode);
    }
  }
  return _radioTheme.radioIconTheme.borderWidth.rest(props.themeMode);
};
const getBorderColor = props => {
  if (props.isDisabled) {
    if (props.isChecked) {
      return _radioTheme.radioBorderTheme.disabled.checked(props.themeMode);
    } else {
      return _radioTheme.radioBorderTheme.disabled.unchecked(props.themeMode);
    }
  }
  if (props.isInvalid) {
    if (props.isActive) {
      return _radioTheme.radioBorderTheme.invalid.active(props.themeMode);
    } else if (props.isHovered) {
      return _radioTheme.radioBorderTheme.invalid.hover(props.themeMode);
    }
    return _radioTheme.radioBorderTheme.invalid.rest(props.themeMode);
  }
  if (props.isChecked) {
    if (props.isActive) {
      return _radioTheme.radioBorderTheme.active.checked(props.themeMode);
    } else if (props.isHovered) {
      return _radioTheme.radioBorderTheme.hover.checked(props.themeMode);
    } else {
      return _radioTheme.radioBorderTheme.rest.checked(props.themeMode);
    }
  }
  if (props.isActive) {
    return _radioTheme.radioBorderTheme.active.unchecked(props.themeMode);
  } else if (props.isHovered) {
    return _radioTheme.radioBorderTheme.hover.unchecked(props.themeMode);
  }
  return _radioTheme.radioBorderTheme.rest.unchecked(props.themeMode);
};
exports.getBorderColor = getBorderColor;
function getBackgroundColor(props) {
  if (props.isChecked || props.isDisabled) {
    return _radioTheme.radioIconTheme.backgroundColor.rest(props.themeMode);
  } else if (props.isActive) {
    return _radioTheme.radioIconTheme.backgroundColor.active(props.themeMode);
  } else if (props.isHovered) {
    return _radioTheme.radioIconTheme.backgroundColor.hover(props.themeMode);
  }
  return _radioTheme.radioIconTheme.backgroundColor.rest(props.themeMode);
}
const RadioIcon = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("div")`
    flex-shrink: 0;
    box-shadow: inset 0 0 0 ${getBorderWidth} ${getBorderColor};
    width: ${_ref => {
  let {
    size
  } = _ref;
  return size === "large" ? "20px" : "16px";
}};
    height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === "large" ? "20px" : "16px";
}};
    padding: 0;
    margin: 0;
    margin-top: ${_ref3 => {
  let {
    size,
    themeMode
  } = _ref3;
  return _radioTheme.radioIconTheme.marginTop[size](themeMode);
}};
    border-radius: 50%;
    transition: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _radioTheme.radioMotionTheme.default(themeMode);
}};

    // the following transforms are only needed for Ursa, but will not hurt Lodestar
    input + div {
        transform: scale(0);
        transition: transform ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return _radioTheme.radioMotionTheme.animation(themeMode);
}},
            opacity ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return _radioTheme.radioMotionTheme.animation(themeMode);
}};
    }
    input:checked + div {
        transform: scale(1);
    }

    background: ${getBackgroundColor};
    cursor: ${props => props.isDisabled ? "not-allowed" : "pointer"};

    // Align the dot in the middle.
    display: flex;
    align-items: center;
    justify-content: center;

    // So the input can be positioned absolutely.
    position: relative;

    ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return (0, _createFocusRingStyles.createFocusRingStyles)({
    theme: themeMode,
    gap: _radioTheme.radioFocusTheme.gap(themeMode),
    componentBorderWidth: 0,
    componentRadius: "50%",
    focusSelector: ":focus-within"
  });
}}
`);
exports.RadioIcon = RadioIcon;
RadioIcon.displayName = "IconWrapper";
//# sourceMappingURL=RadioIcon.js.map